import urlFilter from "../filters/url.filter";
import { ShowCaseActionType } from "./enums/showCaseActionType"; 

/** Класс для данных предодобренного решения */

export class PreApprovedSolutionData {

  /** Текст кнопки закрытия. */
  public CloseActionCaption: string = '';

  /** Текст кнопки действия. */
  public MainActionCaption: string = '';

  /** Признак наличия действия */
  public IsHaveMainAction: boolean = false;

  /** Изображение */
  public Image: string = '';

  /** Изображение для Web*/
  public ImageWeb: string = '';

  /** Html текст. */
  public TextHtml: string = '';
  
  /** Идентификатор */
  public Id: number = 0;

  /** Заголовок. */
  public Caption: string = '';

  /** Тип действия. */
  public ActionType: ShowCaseActionType = ShowCaseActionType.None;

  /** Ссылка действия. */
  public ActionLink: string = '';

  /** Ответы от сервера */
  public Responses: string[] = [];


  constructor(src: any) {
    if(src) {
      this.CloseActionCaption = src.CloseActionCaption ?? '';
      this.MainActionCaption = src.MainActionCaption  ?? '';
      this.IsHaveMainAction = src.IsHaveMainAction  ?? false;
      this.Image = urlFilter(src.Image)  ?? '';
      this.TextHtml = src.TextHtml  ?? '';
      this.Id = src.Id  ?? 0;
      this.Caption = src.Caption  ?? '';
      this.ActionType = (src.ActionType  ?? '') as ShowCaseActionType;
      this.ActionLink = src.ActionLink  ?? '';

      // Парсинг XML из поля Message
      if(src.Message) {
        this.parseXMLMessage(src.Message);
      }

      const responsesArray = typeof src.Responses === "string" ? src.Responses.split('|') : [];

      if (responsesArray.length === 2) {
        this.IsHaveMainAction = true;
        this.MainActionCaption = responsesArray[1];
        this.CloseActionCaption = responsesArray[0];
      } else {
        this.CloseActionCaption = responsesArray.length > 0 ? responsesArray[0] : "НЕ ИНТЕРЕСНО";
      }

    }
  }

  // Парсинг XML
  private parseXMLMessage(message: string): void {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(message, "application/xml");
    const xPAS = xmlDoc.querySelector("PreApprovedSolution");
    const actionTypeValue = xPAS.getAttribute("actionType");

    if(xPAS) {
      this.Image = xPAS.getAttribute("image") ? urlFilter(xPAS.getAttribute("image")!) : this.Image;
      this.ImageWeb = xPAS.getAttribute("imageweb") ? urlFilter(xPAS.getAttribute("imageweb")!) : this.ImageWeb;
      this.ActionType = actionTypeValue as ShowCaseActionType;
      this.ActionLink = xPAS.getAttribute("actionLink") || this.ActionLink;

      this.TextHtml = `<div>${xPAS.textContent}</div>`;
    }
  }

}